import React from "react";
import closeIcon from "../../../../assets/close.svg";

const TagPill = ({ tag, removeTagFromList, isValidTag, index }) => {
  return (
    <div className={`tag-frame${!isValidTag(tag) ? " invalid" : ""}`}>
      <p>{tag}</p>
      <img
        className="close"
        width="12"
        height="12"
        src={closeIcon}
        alt="close"
        onClick={() => removeTagFromList(index)}
      />
    </div>
  );
};

export default TagPill;
